import React from "react";

function WhereToBuy() {
    return (
        <div className="detail-box">      
<h3 align="center">Where To Buy</h3>

<h4 align="center">Affiliates</h4>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox">
        <a title="FiGPiN" target="_blank" rel="noreferrer noopener" href="https://figpin.com/?ref=figpindb"><img alt="FiGPiN" className="where-image" src="logo_figpin.png"/></a>
    </li>
<li className="gallerybox">
        <a title="Entertainment Earth" target="_blank" rel="noreferrer noopener" href="https://www.entertainmentearth.com/?id=P0MJ53HDFA"><img alt="Entertainment Earth" className="where-image" src="logo_ee.png"/></a>
    </li>    
<li className="gallerybox"><a title="Hatcher's Collectibles" target="_blank" rel="noreferrer noopener" href="https://www.hatcherscollectibles.com/?sca_ref=989810.3RBFrS78Vw">
        <img alt="Hatcher's Collectibles" className="where-image" src="logo_hatchers.png"/></a>
    </li>     
    <li className="gallerybox"><a title="Pops and Pins" target="_blank" rel="noreferrer noopener" href="https://www.popsandpins.com/?ref=WBPMzPaO">
        <img alt="Pops and Pins" className="where-image" src="logo_popsandpins.png"/></a>
    </li>    
    <li className="gallerybox"><a title="Ralphie's Funhouse" target="_blank" rel="noreferrer noopener" href="https://ralphiesfunhouse.com/?ref=z6ju5rg3js">
        <img alt="Ralphie's Funhouse" className="where-image" src="logo_ralphies.png"/></a>
    </li>    
    {/*
    <li className="gallerybox"><a title="Three If By Space" target="_blank" rel="noreferrer noopener" href="https://www.threeifbyspace.net/shop/?ref=515">
        <img alt="Three If By Space" className="where-image" src="logo_tibs.png"/></a>
    </li>      

    <li className="gallerybox">
        <a title="vRareStore" target="_blank" rel="noreferrer noopener" href="http://www.vrarestore.com?ref=figpindb"><img alt="vRareStore" className="where-image" src="logo_vrarestore.png"/></a>
    </li>  */} 
</ul>



<h4 align="center">Others</h4>
<ul className="gallery mw-gallery-traditional">

{/*
    <li className="gallerybox">
        <a title="Barnes & Noble" target="_blank" rel="noreferrer noopener" href="http://www.barnesandnoble.com"><img alt="Barnes & Noble" className="where-image" src="logo_bn.png"/></a>
    </li>

    <li className="gallerybox">
        <a title="Best Buy" target="_blank" rel="noreferrer noopener" href="http://www.bestbuy.com"><img alt="Best Buy" className="where-image" src="logo_bestbuy.png"/></a>
    </li>

    <li className="gallerybox">
        <a title="Box Lunch" target="_blank" rel="noreferrer noopener" href="https://www.boxlunch.com/"><img alt="Box Lunch" className="where-image" src="logo_boxlunch.png"/></a>
    </li>        

    <li className="gallerybox">
        <a title="FYE" target="_blank" rel="noreferrer noopener" href="https://www.fye.com/"><img alt="FYE" className="where-image" src="logo_fye.png"/></a>
    </li>        
            */}
    <li className="gallerybox">
        <a title="GameStop" target="_blank" rel="noreferrer noopener" href="https://www.gamestop.com/"><img alt="GameStop" className="where-image" src="logo_gamestop.png"/></a>
    </li>        
{/*
    <li className="gallerybox">
        <a title="Hot Topic" target="_blank" rel="noreferrer noopener" href="https://www.hottopic.com/"><img alt="Hot Topic" className="where-image" src="logo_hottopic.png"/></a>
    </li>        
*/}
    <li className="gallerybox">
        <a title="Target" target="_blank" rel="noreferrer noopener" href="https://www.target.com/"><img alt="Target" className="where-image" src="logo_target.png"/></a>
    </li>        

    <li className="gallerybox">
        <a title="Walmart" target="_blank" rel="noreferrer noopener" href="https://www.walmart.com/"><img alt="Walmart" className="where-image" src="logo_walmart.png"/></a>
    </li>       
    {/* 
    <li className="gallerybox">
        <a title="AMC" target="_blank" rel="noreferrer noopener" href="https://www.amctheatresmoviemerchandise.com/"><img alt="AMC" className="where-image" src="logo_amc.png"/></a>
    </li>        
        */}
    <li className="gallerybox">
        <a title="BAIT" target="_blank" rel="noreferrer noopener" href="http://www.baitme.com"><img alt="BAIT" className="where-image" src="logo_bait.png"/></a>
    </li>
{/*
    <li className="gallerybox">
        <a title="Beehive Collectibles" target="_blank" rel="noreferrer noopener" href="https://beehivecollectibles.com"><img alt="Beehive Collectibles" className="where-image" src="logo_beehive.png"/></a>
    </li>

    <li className="gallerybox">
        <a title="Big Apple Collectibles" target="_blank" rel="noreferrer noopener" href="https://www.bigapplecollectibles.com/"><img alt="Big Apple Collectibles" className="where-image" src="logo_bigapple.png"/></a>
    </li>        
*/}
    <li className="gallerybox">
        <a title="Big Bad Toy Store" target="_blank" rel="noreferrer noopener" href="https://www.bigbadtoystore.com/"><img alt="Big Bad Toy Store" className="where-image" src="logo_bbts.png"/></a>
    </li>        

    <li className="gallerybox">
        <a title="Bump-N-Bite" target="_blank" rel="noreferrer noopener" href="https://bump-n-bite.com/"><img alt="Bump-N-Bite" className="where-image" src="logo_bumpnbite.png"/></a>
    </li>        

    <li className="gallerybox">
        <a title="Chalice Collectibles" target="_blank" rel="noreferrer noopener" href="https://www.chalicecollectibles.com/"><img alt="Chalice Collectibles" className="where-image" src="logo_chalice.png"/></a>
    </li>        
    <li className="gallerybox"><a title="Funimation" target="_blank" rel="noreferrer noopener" href="https://store.crunchyroll.com/">
        <img alt="Funimation" className="where-image" src="logo_crunchyroll.png"/></a>
    </li>    
    <li className="gallerybox">
        <a title="Deep Discount" target="_blank" rel="noreferrer noopener" href="https://www.deepdiscount.com/"><img alt="Deep Discount" className="where-image" src="logo_deepdiscount.png"/></a>
    </li>        
{/*
    <li className="gallerybox">
        <a title="Dragon Eye Gaming" target="_blank" rel="noreferrer noopener" href="http://www.dragoneyegaming.com"><img alt="Dragon Eye Gaming" className="where-image" src="logo_dragoneye.png"/></a>
    </li>
*/}
    <li className="gallerybox">
        <a title="Fry Guy Pins" target="_blank" rel="noreferrer noopener" href="http://www.fryguypins.com"><img alt="Fry Guy Pins" className="where-image" src="logo_fryguy.png"/></a>
    </li>

    <li className="gallerybox"><a title="Fugitive Toys" target="_blank" rel="noreferrer noopener" href="https://www.fugitivetoys.com/">
        <img alt="Fugitive Toys" className="where-image" src="logo_fugitive.png"/></a>
    </li>        

    {/*

    <li className="gallerybox"><a title="Gamer Oasis" target="_blank" rel="noreferrer noopener" href="http://www.gameroasis.com">
        <img alt="Gamer Oasis" className="where-image" src="logo_gameroasis.png"/></a>
    </li>
*/}
    <li className="gallerybox"><a title="Grotto Treasures" target="_blank" rel="noreferrer noopener" href="https://grottotreasures.com">
        <img alt="Grotto Treasures" className="where-image" src="logo_grotto.png"/></a>
    </li>
{/*
    <li className="gallerybox"><a title="I am Retro" target="_blank" rel="noreferrer noopener" href="http://www.iamretro.com">
        <img alt="I am Retro" className="where-image" src="logo_iamretro.png"/></a>
    </li>

    <li className="gallerybox"><a title="Krakens Collection" target="_blank" rel="noreferrer noopener" href="https://www.krakenscollection.com/">
        <img alt="Krakens Collection" className="where-image" src="logo_krakens.png"/></a>
    </li>        
*/}
    <li className="gallerybox"><a title="Megamixx Toys" target="_blank" rel="noreferrer noopener" href="http://www.megamixxtoys.com">
        <img alt="Megamixx Toys" className="where-image" src="logo_megamixx.png"/></a>
    </li>
  
  {/*
    <li className="gallerybox"><a title="Pink a la Mode" target="_blank" rel="noreferrer noopener" href="http://www.pinkalamode.com">
        <img alt="Megamixx Toys" className="where-image" src="logo_pink.png"/></a>
    </li>
*/}
    <li className="gallerybox"><a title="Pins on Fire" target="_blank" rel="noreferrer noopener" href="https://www.pinsonfire.com/">
        <img alt="Pins on Fire" className="where-image" src="logo_pinsonfire.png"/></a>
    </li>        
{/*
    <li className="gallerybox"><a title="POPnBeards" target="_blank" rel="noreferrer noopener" href="http://www.popnbeards.com">
        <img alt="POPnBeards" className="where-image" src="logo_popnbeards.png"/></a>
    </li>
    */}
    <li className="gallerybox"><a title="Poptopia" target="_blank" rel="noreferrer noopener" href="https://www.plasticempire.com">
        <img alt="Plastic Empire" className="where-image" src="logo_pe.png"/></a>
    </li>        
{/*
    <li className="gallerybox"><a title="Poptopia" target="_blank" rel="noreferrer noopener" href="https://www.poptopia.us/">
        <img alt="Poptopia" className="where-image" src="logo_poptopia.png"/></a>
    </li>        

    <li className="gallerybox"><a title="Radar Toys" target="_blank" rel="noreferrer noopener" href="https://www.radartoys.com/">
        <img alt="Radar Toys" className="where-image" src="logo_radar.png"/></a>
    </li>        



    <li className="gallerybox"><a title="Red Panda Collect" target="_blank" rel="noreferrer noopener" href="http://www.redpandacollect.com">
        <img alt="Red Panda Collect" className="where-image" src="logo_redpanda.png"/></a>
    </li>

    <li className="gallerybox"><a title="Shop Pop Online" target="_blank" rel="noreferrer noopener" href="https://www.shoppoponline.com/">
        <img alt="Shop Pop Online" className="where-image" src="logo_shoppop.png"/></a>
    </li>        
*/}

    <li className="gallerybox"><a title="Shumi" target="_blank" rel="noreferrer noopener" href="https://www.shumistore.com/">
        <img alt="Shumi" className="where-image" src="logo_shumi.png"/></a>
    </li>        

    {/*

    <li className="gallerybox"><a title="Stack Em Pops" target="_blank" rel="noreferrer noopener" href="http://www.stackempops.com">
        <img alt="Stack Em Pops" className="where-image" src="logo_stackempops.png"/></a>
    </li>

    <li className="gallerybox">
        <a title="Sweet Baby Collectibles" target="_blank" rel="noreferrer noopener" href="https://www.sweetbabycollectibles.com"><img alt="Sweet Baby Collectibles" className="where-image" src="logo_sweetbaby.png"/></a>
    </li>        
 
    <li className="gallerybox"><a title="Taggem" target="_blank" rel="noreferrer noopener" href="https://www.shoptaggem.com/">
        <img alt="Taggem" className="where-image" src="logo_taggem.png"/></a>
    </li>        

   */}
    <li className="gallerybox"><a title="The Mighty Hobby" target="_blank" rel="noreferrer noopener" href="https://www.themightyhobby.com/">
        <img alt="The Mighty Hobby" className="where-image" src="logo_mighty.png"/></a>
    </li>        

    
{/*
    <li className="gallerybox"><a title="Toy Drops" target="_blank" rel="noreferrer noopener" href="https://www.toydrops.com/">
        <img alt="Toy Drops" className="where-image" src="logo_toydrops.png"/></a>
    </li>        
    */}
    <li className="gallerybox"><a title="Toy Temple" target="_blank" rel="noreferrer noopener" href="https://www.thetoytemple.com/">
        <img alt="Toy Temple" className="where-image" src="logo_toytemple.png"/></a>
    </li>        

    <li className="gallerybox"><a title="Toynk" target="_blank" rel="noreferrer noopener" href="https://www.toynk.com/">
        <img alt="Toynk" className="where-image" src="logo_toynk.png"/></a>
    </li>        

    <li className="gallerybox"><a title="Toy Shnip" target="_blank" rel="noreferrer noopener" href="https://www.toyshnip.com/">
        <img alt="Toy Shnip" className="where-image" src="logo_toyshnip.png"/></a>
    </li>        
{/*
    <li className="gallerybox"><a title="ToyWiz" target="_blank" rel="noreferrer noopener" href="http://www.toywiz.com">
        <img alt="ToyWiz" className="where-image" src="logo_toywiz.png"/></a>
    </li>

    <li className="gallerybox">
        <a title="VLTD" target="_blank" rel="noreferrer noopener" href="https://www.vltd.co/"><img alt="VLTD" className="where-image" src="logo_vltd.png"/></a>
    </li>        

    <li className="gallerybox">
        <a title="WY Super Rare" target="_blank" rel="noreferrer noopener" href="http://www.wysuperrare.com"><img alt="WY Super Rare" className="where-image" src="logo_wysuperrare.png"/></a>
    </li>
*/}
</ul><br/>
<h4 align="center">International</h4>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><a title="Fox & Dragon Hobbies" target="_blank" rel="noreferrer noopener" href="https://www.foxanddragonhobbies.ca/">
        <img alt="Fox & Dragon Hobbies" className="where-image" src="logo_foxdragon.png"/><br/>Canada</a>
    </li>
    <li className="gallerybox"><a title="Mega Zone" target="_blank" rel="noreferrer noopener" href="https://www.megazonevideogames.com/">
        <img alt="Mega Zone" className="where-image" src="logo_megazone.png"/><br/>The Netherlands</a>
    </li>

    {/*
<li className="gallerybox"><a title="Nerds That Collect" target="_blank" rel="noreferrer noopener" href="https://nerdsthatcollect.com">
        <img alt="Nerds That Collect" className="where-image" src="logo_nerds.png"/></a>
    </li>
    */}
</ul>
<br/>
{/*
<p align="center" classname="pinname">FigpinDB is user supported. When you purchase through links on our site, we may earn an affiliate commission.</p>
*/}
        </div>
    );
}

export default WhereToBuy;